package util

import rendering.RendererManager
import three.XRButton

object XRManager {
    init {
        // creating button is important, but we don't have to add it to the DOM
        XRButton.createButton(RendererManager.renderer)
        println("XRManager initialized")
    }
}